/* eslint-disable no-shadow */
import Config from 'es6/core/config';
import { info, error } from 'es6/services/logger';
import { takeLatest } from 'redux-saga';
import { put, call, select } from 'redux-saga/effects';

import { itemsActions, itemsMemoriesActions } from 'es6/redux/modules/items';

import { schedule as scheduleMouseoverDictionaryLoad } from 'iknow-mouseover-dictionary/loader';
import { getItem, getItemMemory } from 'es6/core/api';

const LOG_NS = 'Items Saga';
const logInfo = info.bind(null, LOG_NS);
const logError = error.bind(null, LOG_NS);

export const LOAD_ITEM = 'items/LOAD_ITEM';

// Triggers item loading
export function loadItemAction(id) {
  return { type: LOAD_ITEM, id };
}

export default function* itemsSaga() {
  yield* takeLatest(LOAD_ITEM, loadAll);
}

function* loadAll({ id }) {
  yield [loadItem(id), loadMemory(id)];
}

function* loadItem(id) {
  const willLoad = yield select(({ items }) =>
    !items.getEntity(id) && !items.isLoading(id));

  if (willLoad) {
    try {
      yield put(itemsActions.startLoading(id));
      const item = yield call(getItem, id);
      yield put(itemsActions.put(id, item));

      try {
        yield call(loadMouseoverDictionaries, item);
      } catch (error) {
        logInfo('Couldn\'t load mouseover dictionary', error);
      }
    } catch (error) {
      yield put(itemsActions.setError(id, error));
      if (error.code === 404) {
        logError(`Item ${id} not found`, error);
      } else {
        logError(`Error while loading ${id}`, error);
      }
    }
  }
}

function* loadMemory(id) {
  const willLoad = yield select(({ itemsMemories }) =>
    Config.isLoggedIn() && !itemsMemories.getEntity(id) && !itemsMemories.isLoading(id));

  if (willLoad) {
    try {
      yield put(itemsMemoriesActions.startLoading(id));
      const memory = yield call(getItemMemory, id);
      yield put(itemsMemoriesActions.put(id, memory));
    } catch (error) {
      yield put(itemsMemoriesActions.setError(id, error));
      logInfo(`Memory for item ${id} not found`, error);
    }
  }
}

function loadMouseoverDictionaries(item) {
  const ids = item.goalItems.map(goalItem => goalItem.goal.id);
  return scheduleMouseoverDictionaryLoad({ courses: ids });
}
